import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { InquiryListItem } from './models/inquiry-list-item';

export class InquiryApi {
    constructor(protected baseUrl: string) {}

    public cget = (searchParams?: URLSearchParams): Promise<ApiResult<PaginatedResponse<InquiryListItem>>> => {
        const params = new URLSearchParams(searchParams);
        return safeRequest(
            () => request.get(`${this.baseUrl}/inquiries`, { params }),
            response => response.data
        );
    };
}
